var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Capacity",attrs:{"id":_vm.anim}},[_c('h4',[_vm._v(_vm._s(_vm.msg))]),_c('ul',_vm._l((_vm.details),function(detail,i){return _c('li',{key:i},[_vm._v("+ "+_vm._s(detail))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }